/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import { Button as r } from "@progress/kendo-react-buttons";
import * as o from "react";
const a = (e) => {
  const { view: l, ...t } = e;
  return /* @__PURE__ */ o.createElement(r, { type: "button", fillMode: "flat", themeColor: "primary", ...t }, e.children);
};
export {
  a as CalendarHeaderTitle
};
